module.exports = __webpack_public_path__ + "assets/tag-42300e.svg";